package br.com.vvrefeicoes.portal.data.repository

import br.com.vvrefeicoes.portal.domain.model.OperationalSupplier
import br.com.vvrefeicoes.portal.domain.repository.AuthRepository
import br.com.vvrefeicoes.portal.domain.repository.SupplierRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.contentType
import io.ktor.http.isSuccess
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

class RemoteSupplierRepository(
    private val httpClient: HttpClient,
    private val baseUrl: String,
    private val authRepository: AuthRepository,
) : SupplierRepository {
    override suspend fun loadByCategory(categoryId: String): List<OperationalSupplier> = get<List<SupplierDto>>("/operational/suppliers?categoryId=$categoryId").map { it.toDomain() }

    override suspend fun create(
        categoryId: String,
        name: String,
    ): OperationalSupplier = post<SupplierDto>("/operational/suppliers", SupplierRequestDto(categoria = categoryId, nome = name)).toDomain()

    private suspend inline fun <reified T> get(path: String): T = request { httpClient.get(baseUrl + path) { authorize() } }.body()

    private suspend inline fun <reified T> post(
        path: String,
        body: Any,
    ): T = request { httpClient.post(baseUrl + path) { jsonBody(body) } }.body()

    private suspend inline fun request(
        crossinline call: suspend () -> HttpResponse,
    ): HttpResponse {
        val response = call()
        if (!response.status.isSuccess()) {
            val message =
                runCatching {
                    Json { ignoreUnknownKeys = true }
                        .decodeFromString<SupplierApiErrorDto>(response.bodyAsText())
                        .message
                }.getOrNull()
            error(message ?: "HTTP ${response.status.value}")
        }
        return response
    }

    private fun HttpRequestBuilder.authorize() {
        authRepository.session.value?.token?.let { token ->
            header(HttpHeaders.Authorization, "Bearer $token")
        }
    }

    private fun HttpRequestBuilder.jsonBody(body: Any) {
        authorize()
        contentType(ContentType.Application.Json)
        setBody(body)
    }
}

@Serializable
private data class SupplierRequestDto(
    val categoria: String,
    val nome: String,
)

@Serializable
private data class SupplierDto(
    val id: String,
    val categoria: String,
    val nome: String,
) {
    fun toDomain(): OperationalSupplier = OperationalSupplier(id = id, name = nome, categoryId = categoria)
}

@Serializable
private data class SupplierApiErrorDto(
    val message: String? = null,
)
